import { getApiBase } from "../config/apiBase";

// Logs one click: the source label and the platform, nothing else. No cookies
// (credentials: "omit"), no visitor id, no user agent. keepalive lets the
// request finish after the page has navigated away.
//
// Never rejects: the caller redirects whatever happens here.
export function sendDownloadClick({ source, platform }) {
  try {
    const apiBase = getApiBase();
    if (!apiBase) return Promise.resolve();
    return fetch(`${apiBase}/api/download-click`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source, platform }),
      keepalive: true,
      credentials: "omit",
    }).then(
      () => undefined,
      () => undefined
    );
  } catch (_) {
    return Promise.resolve();
  }
}
